import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import NotificationCenter from './common/NotificationCenter';
import { useSelector } from 'react-redux';

const Header = ({ notifications, markNotificationAsRead, clearNotifications }) => {
    const location = useLocation();
    const { user } = useSelector(state => state.auth);

    // Check if any Settings submenu item is active
    const isSettingsSubmenuActive = 
        location.pathname === '/admin/users' || 
        location.pathname === '/admin/roles' || 
        location.pathname === '/customers';

    // State to track settings menu open/close
    const [settingsOpen, setSettingsOpen] = useState(isSettingsSubmenuActive);

    // Ensure Settings auto-expands when landing directly on any settings route
    useEffect(() => {
        if (isSettingsSubmenuActive) {
            setSettingsOpen(true);
        }
    }, [isSettingsSubmenuActive]);

    useEffect(() => {
        // Remove metisMenu handlers so React fully controls sidebar state
        const disableMetisMenu = () => {
            if (window.$ && window.$('#side-menu').length > 0) {
                const $sideMenu = window.$('#side-menu');
                if ($sideMenu.data && typeof $sideMenu.metisMenu === 'function') {
                    try {
                        $sideMenu.metisMenu('dispose');
                    } catch (err) {
                        // Ignore plugin disposal errors
                    }
                }
            }
        };

        // Re-initialize hamburger menu click handler after component mount
        // This ensures jQuery event binding works with React
        const initHamburgerMenu = () => {
            if (window.$ && window.$('.hide-menu').length > 0) {
                window.$('.hide-menu').off('click').on('click', function(event) {
                    event.preventDefault();
                    if (window.innerWidth < 769) {
                        window.$("body").toggleClass("show-sidebar");
                    } else {
                        window.$("body").toggleClass("hide-sidebar");
                    }
                });
            }
        };

        // Initialize on mount
        disableMetisMenu();
        initHamburgerMenu();

        // Re-initialize on window resize to handle dynamic changes
        const handleResize = () => {
            initHamburgerMenu();
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isActive = (path, queryParam) => {
        if (queryParam) {
            return location.pathname === path && location.search.includes(queryParam);
        }
        return location.pathname === path;
    };
    const isSuperAdmin = user?.role === 'super_admin';
    const isAnchor = user?.userType === 1;
    // Show Anchor menu if user is Anchor OR currently viewing the Anchor Dashboard
    const showAnchorMenu = isAnchor || location.pathname.startsWith('/anchor/');

    const hasPermission = (perm) => isSuperAdmin || user?.permissions?.includes(perm);

    const hasAnyMenuPermission =
      isSuperAdmin ||
      hasPermission('View Leads') ||
      hasPermission('View Anchors') ||
      hasPermission('Manage Users') ||
      hasPermission('View Customers') ||
      hasPermission('View Reports');

    return (
        <div>
            <div id="header">
                <div className="color-line">
                </div>
                <div id="logo" className="light-version">
                    <span>
                        Growbizh
                    </span>
                </div>
                <nav role="navigation">
                    <div 
                        className="header-link hide-menu" 
                        style={{ cursor: 'pointer' }}
                    >
                        <i className="fa fa-bars"></i>
                    </div>
                    <div className="small-logo">
                        <span className="text-primary">Growbizh APP</span>
                    </div>
                    <div className="navbar-right" style={{ marginRight: '15px' }}>
                        <ul className="nav navbar-nav no-borders">
                            <NotificationCenter 
                                notifications={notifications}
                                markNotificationAsRead={markNotificationAsRead}
                                clearNotifications={clearNotifications}
                            />
                            <li className="dropdown">
                                <a href="#" className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" style={{padding: '10px 15px'}}>
                                    <i className="fa fa-user-circle-o" style={{fontSize: '22px'}}></i>
                                </a>
                                <ul className="dropdown-menu" style={{minWidth: '220px', padding: '15px'}}>
                                    <li style={{fontWeight: 'bold', fontSize: '16px', color: '#555'}}>{user?.name || 'User'}</li>
                                    <li style={{fontSize: '14px', color: '#888', marginBottom: '8px'}}>{user?.email || user?.username || ''}</li>
                                    <li role="separator" className="divider" style={{margin: '8px 0'}}></li>
                                    <li><a href="/logout" style={{color: '#d9534f'}}>Log out</a></li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
            <aside id="menu">
                <div id="navigation">
                    <ul className="nav" id="side-menu">
                      {showAnchorMenu ? (
                        <>
                           {/* <li className={isActive('/anchor/dashboard', 'tab=overview') || (location.pathname.includes('/anchor/dashboard') && !location.search.includes('tab=')) ? 'active' : ''}>
                            <a href="/anchor/dashboard?tab=overview"> <span className="nav-label">Overview</span> </a>
                           </li> */}
                           <li className={isActive('/anchor/dashboard', 'tab=invoices') ? 'active' : ''}>
                            <a href="/anchor/dashboard?tab=invoices"> <span className="nav-label">Invoices</span> </a>
                           </li>
                           {/* Hidden as per user request */}
                           {/* <li className={isActive('/anchor/dashboard', 'tab=suppliers') ? 'active' : ''}>
                            <a href="/anchor/dashboard?tab=suppliers"> <span className="nav-label">Suppliers</span> </a>
                           </li> */}
                           {/* <li className={isActive('/anchor/dashboard', 'tab=analytics') ? 'active' : ''}>
                            <a href="/anchor/dashboard?tab=analytics"> <span className="nav-label">Analytics</span> </a>
                           </li>
                           <li className={isActive('/anchor/dashboard', 'tab=settings') ? 'active' : ''}>
                            <a href="/anchor/dashboard?tab=settings"> <span className="nav-label">Settings</span> </a>
                           </li> */}
                           
                           {/* Allow switching back to Admin Dashboard if user is Super Admin */}
                           {isSuperAdmin && (
                             <li style={{ marginTop: '20px', borderTop: '1px solid #444', paddingTop: '10px' }}>
                               <a href="/dashboard"> <i className="fa fa-arrow-left"></i> <span className="nav-label">Back to Admin</span> </a>
                             </li>
                           )}
                        </>
                      ) : hasAnyMenuPermission ? (
                        <>
                          <li className={isActive('/dashboard') ? 'active' : ''}>
                            <a href="/dashboard"> <span className="nav-label">Dashboard</span> </a>
                          </li>
                          {hasPermission('View Leads') && (
                            <li className={isActive('/leads') ? 'active' : ''}>
                                <a href="/leads"> <span className="nav-label">Leads</span> </a>
                            </li>
                          )}
                          {hasPermission('View Invoices') && (
                            <li className={isActive('/admin/anchor-invoices') ? 'active' : ''}>
                                <a href="/admin/anchor-invoices"> <span className="nav-label">Invoices</span> </a>
                            </li>
                          )}
                          {hasPermission('View Anchors') && (
                            <li className={isActive('/anchors') ? 'active' : ''}>
                                <a href="/anchors"> <span className="nav-label">Anchors</span> </a>
                            </li>
                          )}
                          {(hasPermission('Manage Users') || isSuperAdmin || hasPermission('View Customers')) && (
                            <li className={isSettingsSubmenuActive ? 'active' : ''}>
                                <a href="#" onClick={(e) => { e.preventDefault(); e.stopPropagation(); setSettingsOpen(prev => !prev); }}>
                                    <span className="nav-label">Settings</span>
                                    <i className={`fa pull-right ${settingsOpen ? 'fa-chevron-down' : 'fa-chevron-right'}`} style={{ marginTop: '4px', fontSize: '11px', color: '#999' }}></i>
                                </a>
                                {settingsOpen && (
                                    <ul className="nav nav-second-level" style={{ display: 'block' }}>
                                        {hasPermission('Manage Users') && (
                                            <li className={isActive('/admin/users') ? 'active' : ''}>
                                                <a href="/admin/users"> <span className="nav-label">User Management</span> </a>
                                            </li>
                                        )}
                                        {isSuperAdmin && (
                                            <li className={isActive('/admin/roles') ? 'active' : ''}>
                                                <a href="/admin/roles"> <span className="nav-label">Role Management</span> </a>
                                            </li>
                                        )}
                                        {hasPermission('View Customers') && (
                                            <li className={isActive('/customers') ? 'active' : ''}>
                                                <a href="/customers"> <span className="nav-label">Customer Management</span> </a>
                                            </li>
                                        )}
                                    </ul>
                                )}
                            </li>
                          )}
                          {hasPermission('View Reports') && (
                            <li className={isActive('/admin/audit-logs') ? 'active' : ''}>
                                <a href="/admin/audit-logs"> <span className="nav-label">Audit Logs</span> </a>
                            </li>
                          )}
                        </>
                      ) : (
                        <li style={{ color: '#aaa', padding: '10px 20px', fontSize: '14px' }}>
                          No modules available. Please contact your admin.
                        </li>
                      )}
                    </ul>
                </div>
            </aside>
        </div>
    );
}

export default Header;